import React from 'react';
import { connect } from 'react-redux';
import { scoreUntilScenarioSelector } from '../services/store';
import Chapter from '../components/Chapter';
import Scenario from '../components/Scenario';
import Text from '../components/Text';
import Box from '../components/Box';
import haar from '../assets/haar.mp4';

const mapStateToProps = (state) => ({
  score: scoreUntilScenarioSelector(5)(state),
});

const Chapter6 = ({
  id,
  trackEvent,
  score,
}) => (
  <Chapter
    id={id}
    theme="red"
    title="11.00 uur, donderdag"
    media={haar}
    onEnter={() => trackEvent(id)}
  >
    <Text>Je wil met vriendinnen ergens wat gaan lunchen. Je belt naar een restaurant om te reserveren.</Text>
    {score <= 530 ? (
      <Scenario
        id="6"
        title="Wat doe je?"
        description="Het restaurant krijgt, voor jij aan de lijn komt, te horen dat jouw score laag is. Het restaurant blijkt - verrassend - geen plek te hebben voor jou en je vrienden."
        scoreFirst={-20}
        scoreSecond={-20}
        buttonTextFirst="Afspraak afzeggen"
        buttonTextSecond="Negatieve review achterlaten van het restaurant"
        resultTextFirst="Mensen met een lage score kunnen steeds minder in het systeem: uit eten gaan wordt bijvoorbeeld ook moeilijk. Een van je vriendinnen ontvriendt je op social media vanwege je lage score."
        resultTextSecond="Een review plaatsen, zonder dat je bij het restaurant gegeten hebt. Sesame Credit ziet dat je er nooit hebt gegeten en verwijdert jouw nepreview."
        onCallback={(title, choice) => trackEvent(id, choice)}
      />
    ) : (
      <Scenario
        id="6"
        title="Wat doe je?"
        description="Op weg naar het restaurant waar je hebt gereserveerd komen jullie een leuk, nieuw restaurant tegen, met nog genoeg plek. Dus nu moet je kiezen waar je gaat eten."
        scoreFirst={10}
        scoreSecond={-10}
        buttonTextFirst="Het oorspronkelijke restaurant"
        buttonTextSecond="Het nieuwe restaurant"
        resultTextFirst="Goed dat je gaat. Je krijgt een positieve beoordeling van het restaurant."
        resultTextSecond="Zo kort van tevoren afzeggen wordt gezien als onbetrouwbaar gedrag. Dat gaat ten koste van je score."
        onCallback={(title, choice) => trackEvent(id, choice)}
      />
    )}
    <Box>
      <h3>Wanneer wordt het systeem werkelijkheid?</h3>
      <Text>Er is een verschil tussen Sesame Credit en het plan van de overheid. Sesame Credit is vrijwillig, maar vanaf 2020 wordt het systeem van de overheid verplicht. </Text>
    </Box>
  </Chapter>
);

export default connect(mapStateToProps)(Chapter6);



// WEBPACK FOOTER //
// ./src/chapters/Chapter6.js